<template src="./template.html" ></template>

<script>
// @ is an alias to /src
import myDate from '../../../functions/myDate'
import myAxios from '../../../functions/myAxios'
import vueAxios from '../../../functions/vueAxios'
import MyTable from "../../list/Table.vue"
import MyButtons from '../Buttons.vue'
import MyDate from '../../../components/MyDate.vue'
import MyProducts from '../../../components/MyProducts.vue'
// let res = await myAxios({method: 'get', url: `/api/reports?q=${days}`});
export default {
  name: 'MyDaily',
  methods: {
    getRequestParams(type, date, product_id) {
      let params = {}

      if (type) {
        params["type"] = type
      }

      if (date) {
        params["date"] = date
      }

      if (product_id) {
        params["product_id"] = product_id
      }

      return params;
    },
    async retrieveData() {
      const query = this.getRequestParams(
        this.type,
        this.date,
        this.product_id
      );
      // if (this.product_id) query.product_id = this.product_id
      try {
        //
        this.loading = true
        let res = await myAxios({
          method: 'GET',
          url: `/api/reports/daily`,
          params: query
        });
        // console.log(res);
        if (res && res.data) {
          this.data = res.data
          this.data.forEach((row) => {
            if (row.type === 'فروش') {
              row.printInvoice = true;
            }
          })
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    debounceSearch() {
      clearTimeout(this.debounce)
      //
      this.debounce = setTimeout(() => {
        if (!myDate.isValidJalaaliDate(this.date)) {
          return;
        }
        this.page = 1
        this.retrieveData()
      }, 800)
    },
    async setDateValue(item) {
      this.date = item
      this.retrieveData()
    },
    async exportToExcel() {
      const query = this.getRequestParams(
        this.type,
        // ['sale'],
        this.date,
        this.product_id
      );
      // console.log(query);
      const res = await vueAxios.get(`/reports/daily/excel`, {
        params: query,
        responseType: 'blob',
      })
      // if (res?.data?.size < 7000) return
      //
      const blob = new Blob(
        [res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      )

      // ساخت لینک دانلود
      const url = window.URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = url

      // نام فایل
      link.download = `${this.date} - ${this.data.length}`
      // link.download = 'invoices.xlsx'
      document.body.appendChild(link)
      link.click()

      // cleanup
      link.remove()
      window.URL.revokeObjectURL(url)
    },
    // getRoute(type) {
    //   if (['خرید', 'فروش'].includes(type)) {
    //     return 'invoices'
    //   } else if (type === 'دریافت') {
    //     return 'receipts'
    //   } else if (type === 'پرداخت') {
    //     return 'payments'
    //   } else if (['حواله'].includes(type)) {
    //     return 'transfers'
    //   } else if (['دریافت کالا', 'پرداخت کالا'].includes(type)) {
    //     return 'lendings'
    //   }
    // },
  },
  created() {
    this.headers = this.$store.getters.pageInfo.headers
    this.date = myDate.toJalaali(new Date()).date
    // this.debounceSearch()
  },
  data: () => ({
    data: [],
    loading: true,
    // type: ['buy', 'sale', 'rec', 'pay'],
    type: ['sale'],
    product_id: null,
  }),
  components: {
    MyTable,
    MyButtons,
    MyDate,
    MyProducts,
  },
}
</script>

<style lang="scss" scoped>
</style>
